import { Component, Input } from '@angular/core';
import { CommonNgModule } from '../../../shared/modules/common-ng/common-ng.module';

@Component({
  selector: 'app-text',
  standalone: true,
  imports: [
    CommonNgModule
  ],
  templateUrl: './text.component.html',
  styleUrl: './text.component.scss'
})
export class TextComponent {
  @Input() Theme:any;
  @Input() Text:any;

  @Input() Loading_sk: any;

  @Input() RadiusLoading: any;

  
  constructor() { }

  ngOnInit() {
  }
}
